import React, { CSSProperties } from 'react'
import { Box, Icon as MaterialIcon } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import { CssStyles, IconName, NamedColor, NamedSize } from '../../types'
import {
  getClassName,
  isNamedColor,
  isNamedSize,
  parseClassNames,
} from '../../utils'
import { cx } from '@emotion/css'

export interface IIcon {
  /** Screen reader text for the visually impaired and bots.
   *
   */
  alt?: string

  /** The color of the component.
   *
   * @default "inherit"
   */
  color?: NamedColor | string

  /** The icon to display.
   *
   * @default "star"
   */
  iconName?: IconName

  /** The size of the icon in pixels.
   *
   * @default "medium"
   */
  size?: NamedSize | number

  /** *Deprecated* Raw CSS styles
   * @deprecated
   */
  styles?: CssStyles<'root'>

  style?: CSSProperties | string
}

export const Icon = React.forwardRef<HTMLSpanElement, IIcon>(
  (
    {
      alt,
      styles,
      color = 'inherit',
      iconName = 'star',
      size = 24,
      style,
    }: IIcon,
    ref
  ) => {
    const classNames = styles && parseClassNames(styles)

    return (
      <>
        <MaterialIcon
          color={isNamedColor(color) ? color : undefined}
          fontSize={isNamedSize(size) ? size : undefined}
          ref={ref}
          className={cx(classNames?.root, getClassName(style))}
          sx={{
            color: isNamedColor(color) ? undefined : color,
            fontSize: isNamedSize(size) ? undefined : `${size}px !important`,
          }}
        >
          {iconName}
        </MaterialIcon>
        {alt && (
          <Box component="span" style={visuallyHidden}>
            {alt}
          </Box>
        )}
      </>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  Icon.displayName = 'Icon'
}
